import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { formatShowingOf } from '../Carousel.utils';
import ButtonDiscreet from '../../Button/ButtonDiscreet';
import {
  StCarouselFooter,
  StCarouselIndicator,
  StCarouselIndicators,
  StShowingOfText,
} from './FeaturedTrialsCarouselFooter.styles';
import { FeaturedTrialsCarouselFooterProps } from './FeaturedTrialsCarouselFooter.types';

const FeaturedTrialsCarouselFooter = ({
  showingOfTemplate,
  showShowingOf,
  visibleCount,
  totalCount,
  slideCount,
  currentPage,
  onPageChange,
  showIndicators,
  viewAllButtonText,
  viewAllButtonHref,
}: FeaturedTrialsCarouselFooterProps): JSX.Element | null => {
  const showingOfText =
    showShowingOf && showingOfTemplate
      ? formatShowingOf(showingOfTemplate, visibleCount, totalCount)
      : null;

  const showViewAll = Boolean(viewAllButtonText && viewAllButtonHref);

  if (!showingOfText && !showIndicators && !showViewAll) {
    return null;
  }

  const handleViewAllClick = () => {
    if (viewAllButtonHref) {
      window.location.href = viewAllButtonHref;
    }
  };

  return (
    <StCarouselFooter data-testid="featured-trials-carousel-footer">
      {showingOfText && (
        <StShowingOfText data-testid="featured-trials-showing-of">{showingOfText}</StShowingOfText>
      )}
      {showIndicators && slideCount > 1 && (
        <StCarouselIndicators data-testid="featured-trials-carousel-indicators">
          {Array.from({ length: slideCount }, (_, index) => (
            <StCarouselIndicator
              key={index}
              active={index === currentPage}
              aria-label={`Go to slide ${index + 1}`}
              onClick={() => onPageChange(index)}
            >
              <FiberManualRecordIcon sx={{ fontSize: index === currentPage ? '12px' : '8px' }} />
            </StCarouselIndicator>
          ))}
        </StCarouselIndicators>
      )}
      {showViewAll && (
        <ButtonDiscreet onClick={handleViewAllClick}>{viewAllButtonText}</ButtonDiscreet>
      )}
    </StCarouselFooter>
  );
};

export default FeaturedTrialsCarouselFooter;
